import { Stack } from '@/components/layout';
import { Avatar } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { useStyles } from '@/features/player/components/list-player/player-card/player-card-root';
import { useScaling } from '@/hooks';
import { Source } from '@d11/react-native-fast-image';
import { Activity, memo } from 'react';

export const PlayerCardAvatar = memo(
  ({
    size,
    source,
    onPress,
    hideProfileLabel = false,
  }: {
    size: number;
    source?: string | number | Source | undefined;
    onPress: () => void;
    hideProfileLabel?: boolean;
  }) => {
    const styles = useStyles();
    const { scale } = useScaling();

    return (
      <Stack align="center" justify="center">
        <Avatar size={size} onPress={onPress}>
          <Avatar.Image source={source} />
          {/* TODO(typography): replace manual font props with a `variant` token when available. */}
          <Activity mode={hideProfileLabel ? 'hidden' : 'visible'}>
            <Avatar.Label
              fontFamily="Montserrat"
              fontWeight="500"
              fontSize={scale(5)}
              lineHeight={scale(6.5)}
              style={styles.profileLabel}
              letterSpacing={scale(0.2)}>
              {STRINGS.player.profileLabel}
            </Avatar.Label>
          </Activity>
        </Avatar>
      </Stack>
    );
  },
);
